import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { MediaQuery, Carousel } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { Measurement } from './components/Measurement.js';

const FrameMeasurements = ({ measurements  })=>{
    const isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const { getLabel  } = useIntl();
    const title = getLabel('products.measurements.frame.title');
    return /*#__PURE__*/ React__default.createElement("section", {
        className: "product-detail-frame-measurements",
        "aria-label": title
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "product-detail-frame-measurements__container"
    }, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "medium",
        className: "product-detail-frame-measurements__title"
    }, title), /*#__PURE__*/ React__default.createElement("div", {
        className: "product-detail-frame-measurements__items",
        role: "group"
    }, isMobile && /*#__PURE__*/ React__default.createElement(Carousel, {
        pagination: true
    }, measurements.map((item)=>/*#__PURE__*/ React__default.createElement(Measurement, swcHelpers.extends({}, item, {
            key: item.key
        }))
    )), !isMobile && measurements.map((item)=>/*#__PURE__*/ React__default.createElement(Measurement, swcHelpers.extends({}, item, {
            key: item.key
        }))
    ))));
};

export { FrameMeasurements };
//# sourceMappingURL=FrameMeasurements.js.map
